import React, { Suspense, useEffect } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useColorModes } from '@coreui/react-pro'
import PrivateRoute from './privaterouter'
import LazySpinner from './views/system/lazySpinner'
import './scss/style.scss'

// We use those styles to show code examples, you should remove them in your application.
//import './scss/examples.scss'
import AppContext from './AppContext'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Remember = React.lazy(() => import('./views/pages/remember'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const VerifyFicha = React.lazy(() => import('./views/pages/verify/ficha'))
const VerifyCracha = React.lazy(() => import('./views/pages/verify/cracha'))

// Email App
const AvulsoApp = React.lazy(() => import('./views/apps/avulso/AvulsoApp'))
const AvulsoAdd = React.lazy(() => import('./views/apps/avulsoadd'))

const ProducaoApp = React.lazy(() => import('./views/apps/producao'))
const FolhaApp = React.lazy(() => import('./views/apps/folha'))

const SESSION_THEME = process.env.REACT_APP_LOCAL_THEME

const App = () => {
  const { isColorModeSet, setColorMode } = useColorModes(SESSION_THEME)
  const storedTheme = useSelector(state => state.theme)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.href.split('?')[1])
    const theme = urlParams.get('theme') && urlParams.get('theme').match(/^[A-Za-z0-9\s]+/)[0]
    //Se o tema estiver no parametro da URL inicializa
    if (theme) {
      setColorMode(theme)
    }

    if (isColorModeSet()) {
      return
    }

    setColorMode(storedTheme)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <HashRouter>
      <Suspense fallback={<LazySpinner />}>
        <AppContext>
          <Routes>
            <Route exact path="/login" name="Login do usuário" element={<Login />} />
            <Route exact path="/remember" name="Lembrar Senha" element={<Remember />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route
              exact
              path="/verify/ficha"
              name="Autenticação de ficha"
              element={<VerifyFicha />}
            />
            <Route
              exact
              path="/verify/cracha"
              name="Autenticação de crachá"
              element={<VerifyCracha />}
            />

            {/* <Route path="/apps/email/*" name="Email App" element={<EmailApp />} /> */}

            <Route path="/avulso/new" name="Cadastro de Avulso" element={<AvulsoAdd />} />
            <Route path="/avulso/*" name="Painel do Avulso" element={<AvulsoApp />} />

            {/* <Route path="/avulso/:id/*" name="Painel do Avulso" element={<AvulsoApp />} /> */}
            <Route path="/producao/:id" name="Painel de Produção" element={<ProducaoApp />} />
            <Route path="/folha/:id" name="Painel de Folha" element={<FolhaApp />} />
            <Route
              path="*"
              name="Home"
              element={
                <PrivateRoute>
                  <DefaultLayout />
                </PrivateRoute>
              }
            />
          </Routes>
        </AppContext>
      </Suspense>
    </HashRouter>
  )
}

export default App
